// extracted by mini-css-extract-plugin
export default {"fullWidth":"rn-z","image":"sn-z","lazyLoadPicture":"tn-z","lazyLoadSpinner":"un-z","lazyLoadSpin":"vn-z","lazyLoadImage":"wn-z","hasStyledAspectRatio":"xn-z"};